import { render, staticRenderFns } from "./HistoricalImages.vue?vue&type=template&id=34c6a8f7&scoped=true&"
import script from "./HistoricalImages.vue?vue&type=script&lang=js&"
export * from "./HistoricalImages.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalImages.vue?vue&type=style&index=0&id=34c6a8f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6a8f7",
  null
  
)

export default component.exports